import { Wrapper, Header } from "./SpeakingStyle"
import SpeakingSquares from "./01_squares/SpeakingSquares"
import { useSelector } from "react-redux"
import { speaking } from "../../i18n/09_speaking"

const Speaking = () => {
  const lang = useSelector(state => state.lang.lang)
  const t = speaking[lang]

  return (
    <Wrapper>
      <Header>
        {t.heading}
      </Header>
      <SpeakingSquares /> 
    </Wrapper>
  )
}

export default Speaking